import ImageSlider from "./common/ImageSlider";
import Header from "./Header";
import Footer from "./Footer";
import ProjectInfo from "./project-details/ProjectInfo";
import ProjectDescription from "./project-details/ProjectDescription";

const Cinch = () => {
  const images = [
    "assets/img/portfolio/cinch-3.png",
    "assets/img/portfolio/cinch-4.png",
  ];
  const projectData = {
    title: "Cinch Finance",
    stack: "Yoast SEO, Wordpress",
    projectUrl: "https://cinchfin.co.za",
    description: "cinchDesc",
  };

  return (
    <>
      <Header />
      <main id="main">
        <section className="portfolio-details">
          <div className="container">
            <div className="row gy-4">
              <ImageSlider images={images} />

              <div className="col-lg-4">
                <ProjectInfo
                  stack={projectData.stack}
                  projectUrl={projectData.projectUrl}
                />

                <ProjectDescription descriptionKey={projectData.description} />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Cinch;
